import BaseLasStrategy from './BaseLasStrategy';
import { ColorScheme } from './constants';
import lasRunner from './LasRunnerUtil';

class TriggerLoanJourneyStrategy extends BaseLasStrategy {}

type TriggerLoanJourneyArgs = {
  interactionToken?: string;
  /**
   * Optional AbortSignal to cancel an in-flight journey.
   *
   * On abort the SDK confirms the final state with the backend (the same flow
   * as an in-app cancel). In the typical cancellation case this REJECTS with a
   * `ScLoanError` whose `.data` holds the interaction status, so handle it in
   * `.catch`. It resolves only if the backend reports the journey actually
   * completed.
   */
  signal?: AbortSignal;
  /** `dark` | `light` | `system`, forwarded verbatim as the `theme` query param */
  colorScheme?: ColorScheme;
};
async function triggerLoanJourney({
  interactionToken,
  signal,
  colorScheme,
}: TriggerLoanJourneyArgs = {}) {
  const intentStrategy = new TriggerLoanJourneyStrategy(interactionToken, {
    signal,
    colorScheme,
  });
  return lasRunner(intentStrategy);
}

export default triggerLoanJourney;
